import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './style.css'

function App() {
  return (
    <>
    <div className='content'>
      <Routes>
        <Route path="/" element={localStorage.getItem('token') ? <Home/> : <Login />} />
        <Route path="/register" element={localStorage.getItem('token') ? <Navigate to="/" replace='true' /> : <Register />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="*" element={<Navigate to="/" replace='true' />} />
      </Routes>
    </div>
    </>
  );
}

export default App;
